import {Component, OnInit} from '@angular/core';

import {ActivatedRoute, Router} from '@angular/router';

import {HeaderData} from '../../models/header-data';
import {Items} from '../../models/items';
import {AuthenticationService} from '../../services/authentication.service';

@Component({
    selector: 'app-layout',
    templateUrl: './app-layout.component.html',
    styleUrls: ['./app-layout.component.css']
})
export class AppLayoutComponent implements OnInit {
    url: string;
    currentAppLabel: string = '';
    closeOnState: boolean = false;
    menuHeaderData: HeaderData;

    constructor(private route: ActivatedRoute, private router: Router, private authenticationService: AuthenticationService) {
        this.url = this.router.routerState.snapshot.url;
    }

    ngOnInit() {
        this.menuHeaderData = this.route.snapshot.data['menu'];
        if (this.menuHeaderData.appMenu.length > 0) {
            let children: Items[] = this.menuHeaderData.appMenu;
            while (children[0].children !== undefined && children[0].children.length > 0) {
                children = children[0].children;
            }

            let moveTo: string = this.url;
            for (const child of children) {
                if (child.type === 'LINK' && child.referenceType !== 'EXTERNAL_LINK') {
                    if (this.url === '/') {
                        this.setCurrentProgram(child.item_id);
                        this.currentAppLabel = child.label;
                        moveTo = child.reference;
                        break;
                    } else {
                        this.setCurrentProgram(child.item_id);
                        this.currentAppLabel = child.label;
                        if (moveTo === child.reference) {
                            break;
                        }
                    }
                }
            }
            this.router.navigate([moveTo]);
        }
    }

    selectedProgram(item: Items) {
        this.setCurrentProgram(item.item_id);
    }

    private setCurrentProgram(programId: string) {
        this.authenticationService.removeProgram();
        this.authenticationService.setProgram(programId);
    }
}



// WEBPACK FOOTER //
// ./src/app/core/components/app-layout/app-layout.component.ts